import styled from 'styled-components';
import { AiOutlineSelect } from 'react-icons/ai';
import { HiOutlineDocumentReport } from 'react-icons/hi';

export const TaskCardStyle = styled.div`
  .topLabel {
    font-size: 12px;
    font-weight: 300;
    color: #8e8e8e;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .taskName {
    font-size: 14px;
    font-weight: bold;
    color: #2c2c2c;
  }

  .description {
    overflow-wrap: break-word;
    font-size: 12px;
    line-height: normal;
    text-align: left;
    color: #2c2c2c;
  }

  .progressBar {
    width: 100%;
    height: 22.2px;
    margin-bottom: 24px;
    margin-top: 16px;
  }

  .userInfo {
    margin-top: 8px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer {
    width: 245px;
    border: solid red;
  }

  .userImage {
    gap: 4px;
    width: 80%px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .subHeading {
    float: right;
    width: 94px;
    height: 17px;
    margin: 2px 78px 15px 0;
    font-size: 14px;
    text-align: left;
    color: #959595;
  }

  .dialogContainer {
    height: 100px;
    width: 100 px;
    border: solid;
  }

  .userAvatar {
    border: solid;
  }
`;

export const Avatar = styled.div`
  font-size: 8px;
  height: 19px;
  width: 19px;
  background-color: #8e8e8e;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Heading = styled.p`
  margin: 0px 20px 20px 0;
  font-size: 14px;
  text-align: left;
  color: #2c2c2c;
`;

export const Name = styled.span`
  padding: 0;
  text-align: left;
  display: flex;
  align-self: baseline;
`;

export const NoTaskDiv = styled.div`
  height: 85.3px;
  margin: 20px 0px 14.9px 0;
  padding: 96px 50px 96.5px 50px;
  border-radius: 4px;
  background-color: #f5f5f5;
`;
export const NoTaskText = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8e8e8e;
`;
export const Icon = styled(AiOutlineSelect)`
  margin-right: 7px;
  margin-left: 12px;
  transform: scaleX(-1);
  margin-top: 10px;
`;
export const ReportIcon = styled(HiOutlineDocumentReport)`
  margin-right: 7px;
  margin-left: 12px;
  transform: scaleX(-1);
  margin-top: 10px;
`;
